import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IntentService } from '../../../services/intent.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-intent-form',
  imports: [FormsModule, CommonModule],
  templateUrl: './intent-form.component.html',
  styleUrl: './intent-form.component.scss'
})
export class IntentFormComponent implements OnInit {

  isEditMode = false;
  intent: any = {};
  groups: { key: number, value: string }[] = [];

  constructor(private service: IntentService, private route: ActivatedRoute, private router: Router){}

  ngOnInit(): void {
    this.loadGroups();
    
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.isEditMode = true;
      this.loadIntent(id);
    }
  }

  loadGroups() {
    this.service.getIntentGroups().subscribe({
      next: (groups) => {
        this.groups = groups;
      },
      error: (error) => console.error('Error loading groups:', error)
    });
  }

  loadIntent(id: string) {
    this.service.get(id).subscribe({
      next: (data) => {
        this.intent = data;
      },
      error: (error) => {
        console.error('Error loading intent:', error);
        alert('Failed to load intent details. Please try again.');
      }
    });
  }

  onSubmit(): void {
    if (this.isEditMode) {
      this.updateIntent();
    } else {
      this.createIntent();
    }
  }

  createIntent(): void {
    this.service.add(this.intent).subscribe({
      next: (response) => {
        console.log('Intent created successfully');
        this.router.navigate(['/intents']);
      },
      error: (error) => {
        console.error('Error creating intent:', error);
        alert('Failed to create intent. Please try again.');
      }
    });
  }

  updateIntent(): void {
    this.service.update(this.intent.id, this.intent).subscribe({
      next: (response) => {
        console.log('Intent updated successfully');
        this.router.navigate(['/intents']);
      },
      error: (error) => {
        console.error('Error updating intent:', error);
        alert('Failed to update intent. Please try again.');
      }
    });
  }


  cancel(): void {
    this.router.navigate(['/intents']);
  }

}
